



























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, PropSync } from 'vue-property-decorator';
import { BuildingEquipments } from '@/modules/reports/management/domain/building-equipments';
import * as rules from '@/modules/shared/shared/domain/rules';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';

@Component({
    name: 'register-availability-form',
    components: { SectionTitle },
})
export default class RegisterAvailability extends Vue {
    @PropSync('buildingEquipments', { required: true })
    equipments!: BuildingEquipments[];

    @Prop({ required: true, type: Boolean })
    isLoading!: boolean;

    equipmentsData: { [key: string]: { id: number; value?: string } }[] = [];

    rules: any = rules;

    isValid: boolean = true;

    $refs!: {
        form: any;
    };

    get headers(): { text: string; sortable: boolean; measureUnit: string }[] {
        const h: { text: string; sortable: boolean; measureUnit: string }[] = [
            {
                text: 'EQUIPO',
                sortable: false,
                measureUnit: 'NA',
            },
        ];
        this.equipmentsData = [];
        this.equipments.forEach(equipment => {
            let r: { [key: string]: { id: number; value?: string } } = {};
            equipment.parametersEquipments.forEach(parameter => {
                r = {
                    ...r,
                    [parameter.parameter.name]: { id: parameter.id },
                };
                if (!h.find(i => i.text === parameter.parameter.name)) {
                    h.push({
                        text: parameter.parameter.name,
                        sortable: false,
                        measureUnit: parameter.parameter.measureUnit,
                    });
                }
            });
            this.equipmentsData.push(r);
        });
        return h;
    }

    hasParameter(parametersEquipments: { parameter: { name: string } }[], parameterName: string) {
        return !!parametersEquipments.find(parameter => parameter.parameter.name === parameterName);
    }

    register() {
        this.$emit('register', {
            success: this.$refs.form.validate(),
            equipmentsData: this.equipmentsData,
        });
    }
}
